//@flow
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

class Footer extends PureComponent {
  render() {
    const currentYear = new Date().getFullYear();
    return (
      <footer>
        <div className="">
          <div className=""></div>
        </div>
        <p>© {currentYear} metaDoctors</p>
      </footer>
    );
  }
}

export default Footer;
